import { useNavigate } from 'react-router-dom'

export const SHIPMENT_URL = '/shipment/'

export const useGoToShipment = () => {
  const navigate = useNavigate()

  return {
    go: () => {
      navigate(SHIPMENT_URL)
    }
  }
}
